module.exports = __webpack_public_path__ + "img/ewmgzh_01.bf3de799.jpg";